import { reflectKeys } from "@utils/key.reflactor";

export const PREREQUISITE_OPERATOR = reflectKeys(["OR", "AND"]);

export const ACTIVITY_OR_ACTIVITY_QUIZ_CRITERION_PREREQUISITE = reflectKeys([
  "RESOURCE_COMPLETION",
  "RESOURCE_START",
  "RESOURCE_SCORE",
  "QUIZ_SCORE",
  "GAME_AWARD",
  "GAME_CHOICE",
  "LEVEL_UP",
  "QUIZ_RANK",
]);

export const CONDITION_TARGET_TYPE = reflectKeys(["LESSON_ACTIVITY", "GAME_AWARD"]);

export const PREREQUISITE_TYPE = reflectKeys([
  "ACTIVITY",
  "QUIZ_RANK",
  "GAME_AWARD",
  "LEVEL_UP",
  "GAME_CHOICE",
]);

export const MAX_RULES = 20;

export const DEFAULT_MIN_RANK = 1;

export const DEFAULT_MAX_RANK = 10;

export const DEFAULT_LEVEL = 0;
